<div class="access-error-container">
  <h1>{{ 'errors.notEnabledToAccessTitle' | transloco }}</h1>
  <p>{{ 'errors.notEnabledToAccessMessage' | transloco }}</p>
  <button style="justify-content: center" mat-menu-item [routerLink]="['/home']">
    <mat-icon class="icon-item material-icons material-icons--rounded" aria-labelledby="nav-home"
    >home
    </mat-icon>
    <span id="nav-home" class="title-item">{{ 'error.backToHome' | transloco }}</span>
  </button>
</div>
